// This is an entry file for CSS and JS imports

// Import CSS
import './sass/application.scss'

// Include any other scripts
import './scripts/index.js'

// Vue components
import SearchPageContainer from "./scripts/Vue/components/SearchPage/searchPageContainer.vue";
import NewsPageContainer from "./scripts/Vue/components/NewsPage/newsPageContainer.vue";
import EventListPageContainer from "./scripts/Vue/components/EventList/eventListPageContainer.vue";
import {createApp} from "vue";

const searchResultContainerComponent = document.getElementById('search-result-container-component');
const newsPageContainerComponent = document.getElementById('news-page-container-component');
if(searchResultContainerComponent) {
	const searchUrl = searchResultContainerComponent.dataset.searchUrl;
	const rulesUrl = searchResultContainerComponent.dataset.rulesUrl;
    const searchPlaceholderLabel = searchResultContainerComponent.dataset.searchPlaceholderLabel;
    const searchAllLabel = searchResultContainerComponent.dataset.searchAllLabel;
    const searchRulesLabel = searchResultContainerComponent.dataset.searchRulesLabel;
	createApp(SearchPageContainer, {searchUrl, rulesUrl, searchPlaceholderLabel, searchAllLabel, searchRulesLabel})  
		.mount(searchResultContainerComponent); 
}
if(newsPageContainerComponent) {
	const searchUrl = newsPageContainerComponent.dataset.searchUrl;
	createApp(NewsPageContainer, {searchUrl})
		.mount(newsPageContainerComponent);
}

const eventListContainerComponent = document.getElementById('event-list-container-component');
if(eventListContainerComponent) {
	const searchUrl = eventListContainerComponent.dataset.searchUrl;
	const pageId = eventListContainerComponent.dataset.pageId;
	createApp(EventListPageContainer, {searchUrl, pageId})
		.mount(eventListContainerComponent);
}

// Company list page
import CompanyListPage from "./scripts/Vue/company-list-page/CompanyListPage.vue";

const companyListContainer = document.getElementById('company-list-app');

if (companyListContainer) {
    const companiesJson = companyListContainer.dataset.companies;
    const tagsJson = companyListContainer.dataset.tags;
    const title = companyListContainer.dataset.title;
    const lead = companyListContainer.dataset.lead;
    const dropdown = companyListContainer.dataset.dropdown;
    const pageSize = companyListContainer.dataset.pageSize;

    if (companiesJson && tagsJson) {
        const companies = JSON.parse(companiesJson);
        const tags = JSON.parse(tagsJson);

        createApp(CompanyListPage, {
            allItems: companies,
            tags: tags,
            title: title,
            manchet: lead,
            dropdown: dropdown,
            pageSize: pageSize,
        }).mount(companyListContainer);
    }
}

// Case list page
import CaseListPage from "./scripts/Vue/case-list-page/CaseListPage.vue";

const caseListPageContainer = document.getElementById('case-list-app');

if (caseListPageContainer) {
    createApp(CaseListPage, {}).mount(caseListPageContainer);
}